// Import Neon database client
import { neon } from '@neondatabase/serverless';

// Database connection string from environment variables
const DATABASE_URL = process.env.REACT_APP_DATABASE_URL;

// Validate database connection string
if (!DATABASE_URL) {
    throw new Error('Database connection string not found in environment variables');
}

// Initialize database client
export const sql = neon(DATABASE_URL);

// Sanitize input to prevent XSS attacks
const sanitizeInput = (input) => {
    if (typeof input !== 'string') return input;
    return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .trim();
};

// Retrieves all messages from the database, ordered by creation date
export const getMessages = async () => {
    try {
        const messages = await sql`
            SELECT * FROM messages 
            ORDER BY created_at DESC
        `;
        return { data: messages, error: null };
    } catch (error) {
        return { data: null, error };
    }
};

// Inserts a new message into the database with name, message content, and position
export const insertMessage = async ({ name, message, position }) => {
    try {
        // Sanitize user inputs
        const sanitizedName = sanitizeInput(name);
        const sanitizedMessage = sanitizeInput(message);

        // Validate position object
        const sanitizedPosition = {
            x: Number(position.x) || 0,
            y: Number(position.y) || 0
        };

        const result = await sql`
            INSERT INTO messages (name, message, position)
            VALUES (${sanitizedName}, ${sanitizedMessage}, ${JSON.stringify(sanitizedPosition)})
            RETURNING *
        `;
        return { data: result[0], error: null };
    } catch (error) {
        return { data: null, error };
    }
}; 